import { FormTemplate } from '../schema';

export const I130_INTAKE_TEMPLATE: FormTemplate = {
  id: 'i130-intake-v1',
  name: 'Questionário I-130 - Petição Familiar',
  description: 'Coleta de informações para processo de petição familiar I-130',
  category: 'family',
  visaType: 'I-130',
  sections: [
    {
      key: 'petitioner_info',
      title: 'Informações do Peticionário',
      description: 'Pessoa que está fazendo a petição (cidadão ou residente nos EUA)',
      fields: [
        { 
          key: 'pet_full_name', 
          type: 'text', 
          label: 'Nome Completo (como no documento)', 
          required: true,
          fullWidth: true,
          helperText: 'Exatamente como aparece no passaporte ou certidão de nascimento'
        },
        { 
          key: 'pet_other_names', 
          type: 'text', 
          label: 'Outros nomes usados (se houver)', 
          placeholder: 'Nome de solteiro, apelidos oficiais, etc.',
          fullWidth: true
        },
        { 
          key: 'pet_dob', 
          type: 'date', 
          label: 'Data de Nascimento', 
          required: true 
        },
        { 
          key: 'pet_birthplace_city', 
          type: 'text', 
          label: 'Cidade de Nascimento', 
          required: true 
        },
        { 
          key: 'pet_birthplace_country', 
          type: 'country', 
          label: 'País de Nascimento', 
          required: true 
        },
        { 
          key: 'pet_ssn', 
          type: 'ssn', 
          label: 'Social Security Number (SSN)', 
          required: true,
          helperText: 'Formato: XXX-XX-XXXX'
        },
        {
          key: 'pet_a_number',
          type: 'text',
          label: 'A-Number (se tiver)',
          placeholder: 'A-XXXXXXXXX',
          helperText: 'Número de registro de imigrante'
        },
        { 
          key: 'pet_status', 
          type: 'radio', 
          label: 'Status Atual nos EUA', 
          required: true,
          options: [
            { value: 'citizen', label: 'Cidadão Americano' },
            { value: 'lpr', label: 'Residente Permanente (Green Card)' }
          ]
        },
        { 
          key: 'pet_citizenship_how', 
          type: 'select', 
          label: 'Como obteve a cidadania?',
          conditional: { field: 'pet_status', value: 'citizen' },
          options: [
            { value: 'birth_us', label: 'Nascimento nos EUA' },
            { value: 'birth_abroad', label: 'Nascimento no exterior (pais americanos)' },
            { value: 'naturalization', label: 'Naturalização' },
            { value: 'derivation', label: 'Derivação (através dos pais)' }
          ]
        },
        { 
          key: 'pet_citizenship_date', 
          type: 'date', 
          label: 'Data da Cidadania/Naturalização',
          conditional: { field: 'pet_citizenship_how', value: 'naturalization' }
        },
        {
          key: 'pet_gc_date',
          type: 'date',
          label: 'Data que recebeu o Green Card',
          conditional: { field: 'pet_status', value: 'lpr' }
        }
      ]
    },
    {
      key: 'petitioner_contact',
      title: 'Contato do Peticionário',
      fields: [
        {
          key: 'pet_email',
          type: 'email',
          label: 'Email',
          required: true
        },
        {
          key: 'pet_phone',
          type: 'phone',
          label: 'Telefone',
          required: true
        },
        {
          key: 'pet_address',
          type: 'address',
          label: 'Endereço Atual',
          required: true,
          fullWidth: true,
          addressFields: ['street', 'city', 'state', 'zip', 'country']
        }
      ]
    },
    {
      key: 'beneficiary_info',
      title: 'Informações do Beneficiário',
      description: 'Pessoa que será beneficiada pela petição (familiar)',
      fields: [
        { 
          key: 'ben_full_name', 
          type: 'text', 
          label: 'Nome Completo', 
          required: true,
          fullWidth: true
        },
        { 
          key: 'ben_other_names', 
          type: 'text', 
          label: 'Outros nomes usados', 
          fullWidth: true
        },
        {
          key: 'ben_relationship',
          type: 'select',
          label: 'Relação com o Peticionário',
          required: true,
          options: [
            { value: 'spouse', label: 'Cônjuge (marido/esposa)' },
            { value: 'child_under21', label: 'Filho(a) menor de 21 anos, solteiro(a)' },
            { value: 'child_over21', label: 'Filho(a) maior de 21 anos' },
            { value: 'child_married', label: 'Filho(a) casado(a)' },
            { value: 'parent', label: 'Pai ou Mãe' },
            { value: 'sibling', label: 'Irmão ou Irmã' }
          ]
        },
        { 
          key: 'ben_dob', 
          type: 'date', 
          label: 'Data de Nascimento', 
          required: true 
        },
        { 
          key: 'ben_birthplace_city', 
          type: 'text', 
          label: 'Cidade de Nascimento', 
          required: true 
        },
        { 
          key: 'ben_birthplace_country', 
          type: 'country', 
          label: 'País de Nascimento', 
          required: true 
        },
        {
          key: 'ben_gender',
          type: 'radio',
          label: 'Gênero',
          required: true,
          options: [
            { value: 'male', label: 'Masculino' },
            { value: 'female', label: 'Feminino' }
          ]
        },
        {
          key: 'ben_marital_status',
          type: 'select',
          label: 'Estado Civil',
          required: true,
          options: [
            { value: 'single', label: 'Solteiro(a)' },
            { value: 'married', label: 'Casado(a)' },
            { value: 'divorced', label: 'Divorciado(a)' },
            { value: 'widowed', label: 'Viúvo(a)' }
          ]
        }
      ]
    },
    {
      key: 'beneficiary_location',
      title: 'Localização do Beneficiário',
      fields: [
        {
          key: 'ben_currently_in_us',
          type: 'radio',
          label: 'O beneficiário está atualmente nos EUA?',
          required: true,
          options: [
            { value: 'yes', label: 'Sim' },
            { value: 'no', label: 'Não' }
          ]
        },
        {
          key: 'ben_current_address',
          type: 'address',
          label: 'Endereço Atual do Beneficiário',
          required: true,
          fullWidth: true,
          addressFields: ['street', 'city', 'state', 'zip', 'country']
        },
        {
          key: 'ben_us_status',
          type: 'select',
          label: 'Status atual nos EUA',
          conditional: { field: 'ben_currently_in_us', value: 'yes' },
          options: [
            { value: 'tourist', label: 'Turista (B1/B2)' },
            { value: 'student', label: 'Estudante (F-1)' },
            { value: 'work', label: 'Visto de trabalho' },
            { value: 'pending', label: 'Ajuste de status pendente' },
            { value: 'overstay', label: 'Sem status' },
            { value: 'other', label: 'Outro' }
          ]
        }
      ]
    },
    {
      key: 'marriage_info',
      title: 'Informações do Casamento',
      description: 'Apenas se o beneficiário é cônjuge',
      collapsible: true,
      fields: [
        {
          key: 'marriage_date',
          type: 'date',
          label: 'Data do Casamento',
          conditional: { field: 'ben_relationship', value: 'spouse' },
          required: true
        },
        {
          key: 'marriage_city',
          type: 'text',
          label: 'Cidade do Casamento',
          conditional: { field: 'ben_relationship', value: 'spouse' }
        },
        {
          key: 'marriage_country',
          type: 'country',
          label: 'País do Casamento',
          conditional: { field: 'ben_relationship', value: 'spouse' }
        },
        {
          key: 'met_in_person',
          type: 'radio',
          label: 'Vocês se conheceram pessoalmente antes do casamento?',
          conditional: { field: 'ben_relationship', value: 'spouse' },
          options: [
            { value: 'yes', label: 'Sim' },
            { value: 'no', label: 'Não' }
          ]
        },
        {
          key: 'living_together',
          type: 'radio',
          label: 'Vocês moram juntos atualmente?',
          conditional: { field: 'ben_relationship', value: 'spouse' },
          options: [
            { value: 'yes', label: 'Sim' },
            { value: 'no', label: 'Não' }
          ]
        }
      ]
    },
    {
      key: 'previous_marriages',
      title: 'Casamentos Anteriores',
      description: 'Informações sobre casamentos anteriores (de ambos)',
      collapsible: true,
      defaultCollapsed: true,
      fields: [
        {
          key: 'pet_prev_marriages',
          type: 'radio',
          label: 'O peticionário foi casado anteriormente?',
          options: [
            { value: 'yes', label: 'Sim' },
            { value: 'no', label: 'Não' }
          ]
        },
        {
          key: 'pet_prev_marriage_count',
          type: 'number',
          label: 'Quantas vezes?',
          conditional: { field: 'pet_prev_marriages', value: 'yes' }
        },
        {
          key: 'pet_prev_marriage_ended',
          type: 'select',
          label: 'Como terminou o último casamento?',
          conditional: { field: 'pet_prev_marriages', value: 'yes' },
          options: [
            { value: 'divorce', label: 'Divórcio' },
            { value: 'death', label: 'Falecimento' },
            { value: 'annulment', label: 'Anulação' }
          ]
        },
        {
          key: 'ben_prev_marriages',
          type: 'radio',
          label: 'O beneficiário foi casado anteriormente?',
          options: [
            { value: 'yes', label: 'Sim' },
            { value: 'no', label: 'Não' }
          ]
        },
        {
          key: 'ben_prev_marriage_count',
          type: 'number',
          label: 'Quantas vezes?',
          conditional: { field: 'ben_prev_marriages', value: 'yes' }
        }
      ]
    },
    {
      key: 'additional_notes',
      title: 'Informações Adicionais',
      fields: [
        {
          key: 'has_children',
          type: 'radio',
          label: 'O casal tem filhos juntos?',
          conditional: { field: 'ben_relationship', value: 'spouse' },
          options: [
            { value: 'yes', label: 'Sim' },
            { value: 'no', label: 'Não' }
          ]
        },
        {
          key: 'children_count',
          type: 'number',
          label: 'Quantos filhos?',
          conditional: { field: 'has_children', value: 'yes' }
        },
        {
          key: 'criminal_history',
          type: 'radio',
          label: 'Algum dos dois tem histórico criminal?',
          required: true,
          options: [
            { value: 'yes', label: 'Sim' },
            { value: 'no', label: 'Não' }
          ]
        },
        {
          key: 'criminal_details',
          type: 'textarea',
          label: 'Se sim, por favor explique',
          conditional: { field: 'criminal_history', value: 'yes' },
          fullWidth: true
        },
        {
          key: 'immigration_violations',
          type: 'radio',
          label: 'O beneficiário já teve violações de imigração nos EUA?',
          required: true,
          options: [
            { value: 'yes', label: 'Sim' },
            { value: 'no', label: 'Não' }
          ],
          helperText: 'Ex: permanência além do visto, deportação, entrada ilegal'
        },
        {
          key: 'violation_details',
          type: 'textarea',
          label: 'Se sim, por favor explique',
          conditional: { field: 'immigration_violations', value: 'yes' },
          fullWidth: true
        },
        {
          key: 'additional_comments',
          type: 'textarea',
          label: 'Comentários ou informações adicionais',
          placeholder: 'Qualquer outra informação relevante para o caso...',
          fullWidth: true
        }
      ]
    }
  ],
  settings: {
    allowSaveDraft: true,
    showProgress: true,
    requireSignature: false,
    confirmationMessage: 'Obrigado por preencher o questionário! Nossa equipe analisará as informações e entrará em contato em breve.',
    expiresInDays: 14,
    notifyOnComplete: true
  }
};
